module.exports = __webpack_public_path__ + "img/race_600.b0e6c383.png";